import { odooApi } from '../index';
import { getOdooLang } from '@/config/api.config';
import { extractErrorMessage } from '../transforms';

export interface UrPlatform {
  id: string;
  name: string;
  url: string;
}

interface OdooUrPlatform {
  id?: number;
  name?: string;
  url?: string;
}

interface OdooUrPlatformsResponse {
  success: boolean;
  data: OdooUrPlatform[];
  total_records?: number;
  language?: string;
}

export const urPlatformsApi = odooApi.injectEndpoints({
  endpoints: (builder) => ({
    getUrPlatforms: builder.query<UrPlatform[], { lang?: 'ar' | 'en' | 'ku' } | void>({
      query: (arg) => {
        const odooLang = getOdooLang(arg?.lang || 'ar');
        const params = new URLSearchParams({
          lang: odooLang,
        });

        return {
          url: `/api/moys/ur-platforms?${params.toString()}`,
          method: 'GET',
        };
      },
      transformResponse: (response: OdooUrPlatformsResponse) =>
        (response.data || []).map((platform, index) => ({
          id: String(platform.id ?? index + 1),
          name: platform.name || '',
          url: platform.url || '',
        })),
      transformErrorResponse: (response) => extractErrorMessage(response),
      providesTags: (result) => {
        if (!result) {
          return [{ type: 'Platform' as const, id: 'LIST' }];
        }

        return [
          ...result.map((platform) => ({ type: 'Platform' as const, id: platform.id })),
          { type: 'Platform' as const, id: 'LIST' },
        ];
      },
    }),
  }),
});

export const { useGetUrPlatformsQuery } = urPlatformsApi;
